import { useMemo } from "react";
import type { Moment } from "moment";
import { mixed, object, string } from "yup";
import { FormField } from "./types";

export const useMerchantBusinessValidationSchema = () =>
    useMemo(() =>
        object().shape({
            [FormField.BusinessName]: string()
                .required()
                .max(255)
                .trim()
                .label('Business Name')
        })
        , []);

export const useMerchantDomainValidationSchema = () =>
    useMemo(() =>
        object().shape({
            [FormField.SourceUrl]: string()
                .required()
                .max(255)
                .url()
                .trim()
                .label('Domain URL'),

            [FormField.ExpiresAtDate]: mixed()
                .nullable()
                .test(
                    'valid-expiration-date',
                    function (value: Moment | null) {
                        if (!value || value.isValid()) {
                            return true;
                        }

                        return this.createError({
                            message: 'Invalid date format for expiration date.'
                        });
                    })
                .label('Expiration Date')
        })
        , []);
